// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".body-copy.home-snippet[data-v-4031f867]{margin-bottom:0}.body-copy.home-snippet>h2[data-v-4031f867]{line-height:1.1875;margin-bottom:16px}.updated-text[data-v-4031f867]{display:flex;align-items:center;justify-content:flex-start;color:#37474f}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
